import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const deleteReturnViewFolder = {
  name: "deleteReturnViewFolder" as const,
  input: z.object({ folderId: z.string(), type: createEnum(ReturnTypeEnum) }),
  output: z.object({}),
};
